import { getServiceName } from './getServiceName';
import { getCategoryName } from './getCategoryName';
const dayjs = require('dayjs');

export const getData = (selectedPeriod, state) => {
  const {
    id,
    durationInDays,
    count,
    services,
    serviceDurationInDays,
    marketingPricePerDay,
    pricePerDay,
    totalMarketingPrice,
    totalPrice,
    discount,
    auctionPoints,
    cashbackPercent,
    regionNames,
  } = selectedPeriod;

  const serviceName = getServiceName(services);
  const categoryName = getCategoryName(state);

  const items = [
    {
      count,
      services,
      serviceDurationInDays,
      marketingPricePerDay,
      pricePerDay,
      serviceName,
    },
  ];

  return {
    regionName: regionNames.join(', '),
    packageId: id,
    categoryName,
    startDate: dayjs().format('DD.MM.YYYY'),
    endDate: dayjs().add(durationInDays, 'days').format('DD.MM.YYYY'),
    durationInDays,
    items,
    discount,
    totalMarketingPrice,
    totalPrice,
    auctionPoints,
    cashbackPercent,
  };
};
